import { IconButton, Tooltip } from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import useStructureSet from '~/hooks/structure-set/useStructureSet';

export default function DisplayStructuresToggle() {
    const { structureSet, setStructureSetVisibility, setRoisVisibility } =
        useStructureSet();

    const handleStructureSetVisibilityToggle = (
        newVisibilityStatus: boolean
    ) => {
        setStructureSetVisibility(newVisibilityStatus);
        setRoisVisibility(newVisibilityStatus);
    };

    return (
        <Tooltip
            title={
                structureSet?.visible ? (
                    <FormattedMessage id="hideStructures" />
                ) : (
                    <FormattedMessage id="showStructures" />
                )
            }
            enterDelay={500}
            enterNextDelay={500}
        >
            <IconButton
                color="primary"
                size="small"
                aria-controls="image-picker-menu"
                aria-haspopup="true"
                data-testid="display-structures-toggle"
                onClick={() =>
                    handleStructureSetVisibilityToggle(!structureSet?.visible)
                }
                sx={{
                    p: 1,
                    backgroundColor: structureSet?.visible
                        ? 'inherit'
                        : 'rgba(0,165,185,0.08)',
                }}
            >
                {structureSet?.visible ? (
                    <Eye size={12} aria-label="display-structures-toggle-eye" />
                ) : (
                    <EyeOff
                        size={12}
                        aria-label="display-structures-toggle-eyeoff"
                    />
                )}
            </IconButton>
        </Tooltip>
    );
}
